import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import S from 'commons/styles/sto-list-page.styles';
import { STOItem } from 'commons/types';
import { getSTOPickItemsAction } from 'redux-stores/actions';
import { RootReducerInterface } from 'redux-stores/reducers';
import { AppDispatch } from 'redux-stores/store';
import { STO_PICK_ROUTES } from 'routes/constants';

import { STOPickListTable } from './components/STOPickListRow.component';

export const STOPickListPage: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { assignedSTOItems } = useSelector(
    (state: RootReducerInterface) => state.stoPickItem,
  );

  const [filter, setFilter] = useState<string>('');
  const [disableProceedButton, setDisableProceedButton] =
    useState<boolean>(true);
  const [displayedItems, setDisplayedItems] =
    useState<STOItem[]>(assignedSTOItems);

  useEffect(() => {
    dispatch(getSTOPickItemsAction());
  }, [dispatch]);

  useEffect(() => {
    setDisplayedItems(assignedSTOItems);
  }, [assignedSTOItems, dispatch]);

  const onFilterChange = (value: string): void => {
    setFilter(value);
    if (value === '') {
      setDisplayedItems(assignedSTOItems);
    } else {
      const filteredIdx: number[] = [];
      const filteredItems = assignedSTOItems.filter((task, idx) => {
        if (task.sku_code.includes(value)) {
          filteredIdx.push(idx);
          return true;
        }
        return false;
      });
      setDisplayedItems(filteredItems);
    }
  };

  return (
    <div>
      <S.ContentWrapper>
        <S.SubtitleWrapper container>
          <S.Subtitle item xs={12} data-testid="STOTextListPick">
            STO Pick List
          </S.Subtitle>
        </S.SubtitleWrapper>
        <S.SearchBar
          placeholder="SKU Number or Scan"
          variant="outlined"
          value={filter}
          onChange={(event) => onFilterChange(event.target.value)}
          inputProps={{
            'data-testid': 'InputListSKU',
          }}
        />

        <STOPickListTable
          stoItems={displayedItems}
          setDisableProceedButton={setDisableProceedButton}
        />
        <S.BlankWhiteSpace />
      </S.ContentWrapper>
      {/* Footer Section */}
      <S.FooterWrapper>
        <S.PrimaryButton
          disabled={disableProceedButton}
          onClick={() => navigate(STO_PICK_ROUTES.SUMMARY)}
          data-testid="BtnListProceed"
        >
          PROCEED
        </S.PrimaryButton>
      </S.FooterWrapper>
    </div>
  );
};
